import i18next from "i18next";
import { get, isNull, isNumber, isObject, isString, isUndefined } from "lodash";
import { DATA_STATUS_TYPES } from "~/constans/statuses";
import { NOTIFICATIONS } from "~/constans/notifications";

export const language = localStorage.getItem("language");

export const getSelectValues = (arr = []) => {
  const arrayOnlyValue = arr.map((i) => i.value);
  return arrayOnlyValue;
};

export const getIndicatorName = (ind): string => {
  if (!ind) {
    return "";
  }
  let language = localStorage.getItem("language");
  const { nameEn, shortNameEn, nameRu, shortNameRu } = ind;
  const finalName =
    language === "en"
      ? nameEn || shortNameEn || nameRu || shortNameRu
      : nameRu || shortNameRu || nameEn || shortNameEn;
  return finalName;
};

export const getIndicatorValue = (
  indicator = {},
  round = undefined,
  formatNumber = undefined,
  indValue = undefined
) => {
  const format = get(indicator, `format`, "double");
  const unit = get(indicator, `unit`, "");

  let indicatorValue =
    isNumber(indValue) || isString(indValue)
      ? indValue
      : isUndefined(indValue)
      ? get(indicator, `Values[0].${format}Value`, DATA_STATUS_TYPES.DASH)
      : DATA_STATUS_TYPES.DASH;

  indicatorValue = isNull(indicatorValue)
    ? DATA_STATUS_TYPES.DASH
    : indicatorValue;

  const formatRoundNumber = (number, round, format) => {
    let result = number;
    if (!isNaN(round) && !isNull(round)) {
      if (!isNumber(result) || !isNumber(round)) return DATA_STATUS_TYPES.ND;
      let num_sign = result >= 0 ? 1 : -1;
      result = (
        Math.round(result * Math.pow(10, round) + num_sign * 0.0001) /
        Math.pow(10, round)
      ).toFixed(round);
    }
    if (!isNaN(format) && !isNull(format)) {
      result = parseFloat(result).toFixed(format);
    }
    return result;
  };

  const isRound = !isNaN(parseFloat(indicatorValue));
  switch (unit) {
    case "Place":
    case "Unit":
    case "item":
    case "":
      indicatorValue = isRound
        ? formatRoundNumber(indicatorValue, round, formatNumber)
        : indicatorValue;
      break;
    case "percent":
      indicatorValue = isRound
        ? formatRoundNumber(indicatorValue, round, formatNumber) + "%"
        : indicatorValue !== DATA_STATUS_TYPES.DASH
        ? indicatorValue + "%"
        : indicatorValue;
      break;
    case "Rub":
    case "ThndRub":
    case "MilnRub":
      indicatorValue =
        round !== null && indicatorValue !== DATA_STATUS_TYPES.DASH
          ? formatRoundNumber(indicatorValue, round, formatNumber)
          : indicatorValue;
      break;
  }

  return indicatorValue;
};

export const getIndicatorValueSum = (
  processedIndicators = []
  // FactCertificationCountSum = 0,
  // PercentCertificationCountSum = 0
) => {
  let countPercentCertificatedSum = 0;
  function test(acc: any, indicator: any) {
    countPercentCertificatedSum = countPercentCertificatedSum + 1;
    return (
      acc.PercentCertificatedSum +
      Number(indicator.percentCertificated.slice(0, -1))
    );
  }
  let countPercentRequiredSum = 0;
  function test2(acc: any, indicator: any) {
    countPercentRequiredSum = countPercentRequiredSum + 1;
    return (
      acc.PercentRequiredSum +
      +Math.round(Number(indicator.percentRequired.slice(0, -1)))
    );
  }
  let countPercentTrainingSum = 0;
  function test3(acc: any, indicator: any) {
    countPercentTrainingSum = countPercentTrainingSum + 1;
    return (
      acc.PercentTrainingSum + +Number(indicator.percentTraining.slice(0, -1))
    );
  }
  let countPercentCountSum = 0;
  function test4(acc: any, indicator: any) {
    countPercentCountSum = countPercentCountSum + 1;
    return acc.PercentCountSum + +Number(indicator.percentNumber.slice(0, -1));
  }
  const indicatorValueSum = processedIndicators.reduce(
    (accumulator, indicator) => {
      accumulator = {
        ...accumulator,

        //Number
        StandardCountSum:
          indicator.standardNumber !== DATA_STATUS_TYPES.DASH
            ? accumulator.StandardCountSum + +indicator.standardNumber
            : accumulator.StandardCountSum,

        FactCountSum:
          indicator.factNumber !== DATA_STATUS_TYPES.DASH
            ? accumulator.FactCountSum + +indicator.factNumber
            : accumulator.FactCountSum,
        PercentCountSum:
          indicator.percentNumber !== DATA_STATUS_TYPES.DASH
            ? test4(accumulator, indicator)
            : accumulator.PercentCountSum,

        // //Training
        // FactTrainingSum:
        //   indicator.factTraining !== DATA_STATUS_TYPES.DASH
        //     ? accumulator.FactTrainingSum + +indicator.factTraining
        //     : accumulator.FactTrainingSum,
        // PercentTrainingSum:
        //   indicator.percentTraining !== DATA_STATUS_TYPES.DASH
        //     ? test3(accumulator, indicator)
        //     : accumulator.PercentTrainingSum,
        // //Certification
        // //Require
        // PersonRequiredSum:
        //   indicator.personRequired !== DATA_STATUS_TYPES.DASH
        //     ? accumulator.PersonRequiredSum + +indicator.personRequired
        //     : accumulator.PersonRequiredSum,
        // PercentRequiredSum:
        //   indicator.percentRequired !== DATA_STATUS_TYPES.DASH
        //     ? test2(accumulator, indicator)
        //     : accumulator.PercentRequiredSum,
        // //Certificated
        // PersonCertificatedSum:
        //   indicator.personCertificated !== DATA_STATUS_TYPES.DASH
        //     ? accumulator.PersonCertificatedSum + +indicator.personCertificated
        //     : accumulator.PersonCertificatedSum,
        // PercentCertificatedSum:
        //   indicator.percentCertificated !== DATA_STATUS_TYPES.DASH
        //     ? test(accumulator, indicator)
        //     : accumulator.PercentCertificatedSum,
      };

      return accumulator;
    },
    {
      StandardCountSum: 0,
      FactCountSum: 0,
      PercentCountSum: 0,
      // FactTrainingSum: 0,
      // PercentTrainingSum: 0,
      // PersonRequiredSum: 0,
      // PercentRequiredSum: 0,
      // PersonCertificatedSum: 0,
      // PercentCertificatedSum: 0,
    }
  );

  //Number
  indicatorValueSum.PercentCountSum = indicatorValueSum.PercentCountSum
    ? (indicatorValueSum.PercentCountSum / countPercentCountSum).toFixed(1) +
      "%"
    : DATA_STATUS_TYPES.ND;
  //Training
  // indicatorValueSum.FactTrainingSum =
  //   indicatorValueSum.FactTrainingSum || DATA_STATUS_TYPES.ND;
  // indicatorValueSum.PercentTrainingSum = indicatorValueSum.PercentTrainingSum
  //   ? (indicatorValueSum.PercentTrainingSum / countPercentTrainingSum).toFixed(
  //       1
  //     ) + "%"
  //   : DATA_STATUS_TYPES.ND;
  //Required
  // indicatorValueSum.PersonRequiredSum =
  //   indicatorValueSum.PersonRequiredSum || DATA_STATUS_TYPES.ND;
  // indicatorValueSum.PercentRequiredSum = indicatorValueSum.PercentRequiredSum
  //   ? (indicatorValueSum.PercentRequiredSum / countPercentRequiredSum).toFixed(
  //       1
  //     ) + "%"
  //   : DATA_STATUS_TYPES.ND;
  // //Certificated
  // indicatorValueSum.PersonCertificatedSum =
  //   indicatorValueSum.PersonCertificatedSum || DATA_STATUS_TYPES.ND;
  // indicatorValueSum.PercentCertificatedSum =
  //   indicatorValueSum.PercentCertificatedSum
  //     ? (
  //         indicatorValueSum.PercentCertificatedSum / countPercentCertificatedSum
  //       ).toFixed(1) + "%"
  //     : DATA_STATUS_TYPES.ND;

  //     getPercentage(
  //   indicatorValueSum.StandardCountSum,
  //   indicatorValueSum.FactCountSum
  // );

  return {
    ...indicatorValueSum,
    PercentCountSum:
      indicatorValueSum.PercentCountSum === DATA_STATUS_TYPES.DASH
        ? DATA_STATUS_TYPES.ND
        : indicatorValueSum.PercentCountSum,
  };
};

export const getShortUserName = (fullName = ""): string => {
  if (fullName) {
    const arraynames = fullName.split(" ");
    const firstName = arraynames[0];
    const middleName = arraynames[1];
    const lastName = arraynames[2];

    let mid = middleName ? `${middleName[0]}.` : "";
    let last = lastName ? `${lastName[0]}.` : "";

    if (!lastName) {
      return `${firstName} ${mid}`;
    }

    return `${firstName} ${mid}${last}`;
  }
};

export const getCallableNumber = (number: string | number = 0): string => {
  return String(number).replace(/[^+\d]/g, "");
};

export const getPercentage = (plan, fact) => {
  // if (isNaN(plan) || isNaN(fact)) {
  //   return DATA_STATUS_TYPES.ND;
  // }
  const formatPlan = get(plan, `format`, "double");
  const formatFact = get(fact, `format`, "double");

  let planValue = get(
    plan,
    `Values[0].${formatPlan}Value`,
    DATA_STATUS_TYPES.DASH
  );
  let factValue = get(
    fact,
    `Values[0].${formatFact}Value`,
    DATA_STATUS_TYPES.DASH
  );

  if (isNumber(plan) && isNumber(fact)) {
    planValue = plan;
    factValue = fact;
  }

  let percent = "";

  let isPlanNumber = isNumber(planValue);
  let isFactNumber = isNumber(factValue);
  if (isPlanNumber && isFactNumber) {
    planValue = isPlanNumber ? planValue : 0;
    factValue = isFactNumber ? factValue : 0;

    if (planValue === 0 && factValue > 0) {
      return "100%";
    }

    if (planValue === 0 && factValue === 0) {
      return "0%";
    }

    percent = `${(factValue / planValue) * 100}`;
  } else {
    return DATA_STATUS_TYPES.DASH;
  }

  if (percent.indexOf(".") > -1) {
    return `${parseFloat(percent).toFixed(2)}%`;
  }

  return percent + "%";
};

export const diffJSON = (obj1, obj2) => {
  const diff = {};
  const obj1Keys = Object.keys(obj1);
  if (!obj1 || !obj2) return null;

  for (let objKey of obj1Keys) {
    if (
      objKey !== "createdAt" &&
      !(isNull(obj1[objKey]) && isNull(obj2[objKey]))
    ) {
      if (obj1[objKey] !== obj2[objKey]) {
        if (isObject(obj1[objKey]) && isObject(obj2[objKey])) {
          let res = diffJSON(obj1[objKey], obj2[objKey]);
          for (const key in res) {
            diff[key] = res[key];
          }
        } else {
          diff[objKey] = [obj1[objKey], obj2[objKey]];
        }
      } else {
        if (!isObject(obj2[objKey])) {
          diff[objKey] = obj2[objKey];
        }
      }
    }
  }

  return diff;
};

export const hasWarningInErrors = ({ errors }, t) => {
  switch (errors?.notice?.level) {
    case "warning":
      return {
        type: NOTIFICATIONS.error,
        description: t("errors.upload_data_is_not_ready"),
      };
    case "notice":
      return {
        type: NOTIFICATIONS.warning,
        description: t("errors.upload_data_is_ready_however"),
      };
    default:
      return {
        type: NOTIFICATIONS.success,
        description: t("errors.upload_success_data_however"),
      };
  }
};

export const hasErrors = ({ errors }) => {
  return get(errors, "notice", null);
};

export const setDefaultSelectR = (rating, ratingName) =>
  rating && ratingName
    ? {
        value: rating,
        label: `(${rating}) ${ratingName}`,
      }
    : null;

export const defaultSelectElem = (element, elementName, elementType) => ({
  value: element || null,
  label: element
    ? `(${element}) ${elementName}`
    : elementType === "parent"
    ? i18next.t("common.without_parent")
    : element
    ? i18next.t("common.without_predecessor")
    : i18next.t("common.new"),
});

export const getNameSelection = (name, data) => {
  let isRu = localStorage.getItem("language") === "ru";
  return isRu ? data[name] : data[`${name}En`];
};
